import FilledButtonM from "@common/components/button/FilledButtonM"
import TextM from "@common/components/text/TextM"
import TitleM from "@common/components/text/TitleM"
import { theme } from "@common/theme/theme"
import { DimensionsContext, IS_WEB } from "@common/utils/mobileUtils"
import { apiIdle, apiRequest } from "@data/redux/actions/api"
import { studentsService } from "@data/services/studentsService"
import { useNavigation } from "@react-navigation/native"
import React, { useCallback, useContext, useState } from "react"
import { FlatList, View } from "react-native"
import { ActivityIndicator, IconButton } from "react-native-paper"
import { connect } from "react-redux"
import { useFocusEffect } from "@react-navigation/native"
import StudentsListItem from "./StudentsListItem"
import GenerateActivityModal from "./GenerateActivityModal"

const MyStudentsTabScreen = (props) => {
    const navigation = useNavigation()
    const [showGenerateActivityModal, setShowGenerateActivityModal] = useState(false)

    const dimensions = useContext(DimensionsContext)

    // Fetch students data when screen comes into focus
    useFocusEffect(
        useCallback(() => {
            props.apiRequest(studentsService.getStudents)
        }, [])
    )

    return (
        <View
            style={{
                flex: 1,
                backgroundColor: theme.colors.whiteAlmost,
                alignItems: "center",
                width: dimensions?.width,
                alignSelf: "center",
            }}
        >
            {IS_WEB &&
            props.getStudentRequest &&
            !props.user?.students?.length > 0 ? (
                <ActivityIndicator
                    animating={true}
                    style={{
                        marginTop: 50,
                    }}
                    color={theme.colors.primary}
                />
            ) : (
                <FlatList
                    data={props.user.students}
                    refreshing={!!props.getStudentRequest}
                    onRefresh={() =>
                        props.apiRequest(studentsService.getStudents)
                    }
                    style={{
                        width: dimensions?.width,
                    }}
                    ListEmptyComponent={() => (
                        <>
                            <TextM
                                style={{
                                    textAlign: "center",
                                    marginTop: 0,
                                }}
                            >
                                Aucun élève
                            </TextM>
                        </>
                    )}
                    ListHeaderComponent={() => (
                        <>
                            <View
                                style={{
                                    flexDirection: "row",
                                    alignItems: "center",
                                    justifyContent: "space-between",
                                    width: dimensions?.width,
                                    borderColor: theme.colors.lightMore,
                                    paddingVertical: 8,
                                    paddingHorizontal: 10,
                                    marginBottom: 20,
                                }}
                            >
                                <View style={{ marginLeft: 10 }}>
                                    <TitleM fontWeight="ExtraBold">MES ÉLÈVES</TitleM>
                                </View>

                                <View
                                    style={{
                                        flexDirection: "row",
                                        alignItems: "center",
                                        marginRight: 0
                                    }}
                                >
                                    <>
                                        {props.user?.students?.length > 0 && (
                                            <FilledButtonM
                                                onPress={() => {
                                                    setShowGenerateActivityModal(true)
                                                }}
                                                icon={"plus"}
                                                style={{
                                                    marginBottom: 0,
                                                    maxWidth: 130,
                                                    marginRight: 10,
                                                }}
                                                contentStyle={{
                                                    maxWidth: 130,
                                                    height: 30,
                                                }}
                                                labelStyle={{
                                                    fontSize: 11,
                                                }}
                                                color={theme.colors.primary}
                                                label={"Activité"}
                                            />
                                        )}
                                         <IconButton
                                            onPress={() => {
                                                props.apiRequest(studentsService.getStudents)
                                            }}
                                            loading={IS_WEB && props.getStudentRequest}
                                            iconColor={theme.colors.primary}
                                            containerColor={
                                                theme.colors.transparent
                                            }
                                            disabled={props.getStudentRequest}
                                            icon={"sync-alt"}
                                            size={20}
                                        />
                                    </>
                                </View>
                            </View>
                        </>
                    )}
                    renderItem={(item) => {
                        return (
                            <StudentsListItem
                                student={item.item}
                                index={item.index}
                            />
                        )
                    }}
                />
            )}

            {/* Generate Activity Modal for multi-student */}
            {showGenerateActivityModal && (
                <GenerateActivityModal
                    isOpen={showGenerateActivityModal}
                    onClose={() => setShowGenerateActivityModal(false)}
                    student={null}
                    schoolSubjects={props.schoolSubjects}
                    forStudents={true}
                    studentsList={props.user?.students}
                    nav={navigation}
                />
            )}
        </View>
    )
}

const mapStateToProps = (state) => {
    return {
        user: state.data.currentUser?.object,
        getStudentRequest: state.api.getStudents?.request,
        schoolSubjects: state.data.staticData?.school_subjects,
    }
}

const mapDispatchToProps = {
    apiRequest,
    apiIdle,
}

export default connect(mapStateToProps, mapDispatchToProps)(MyStudentsTabScreen)
